'use strict';

import { observable, observe, configure, action, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import appStore from "@uw-it-sis/lib-react/lib/AppStore";

import termStore from "@uw-it-sis/lib-react/lib/TermStore";
import {getAggregateState} from "@uw-it-sis/lib-react/lib/StateUtils";
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import {stripQueryParams} from '@uw-it-sis/lib-react/lib/Utils';

class AppNavigationStore {

    state = States.initial;

    navigationCompareLocation = "";

    navigationComparePathname = "";

    constructor() {
        makeObservable(this, {
            state: observable,
            navigationCompareLocation: observable,
            navigationComparePathname: observable,
            mount: action,
            resetNavigationCompareLocation: action,
            checkDataLoadStates: action
        });

        this.dataLoadStates = {
            internalProcessing: States.initial,
            currentPlanableTerm: States.initial
        }
    }

    mount() {

        this.dataLoadStates = {
            internalProcessing: States.pending,
            currentPlanableTerm: States.pending
        };

        this.checkDataLoadStates();

        this.resetNavigationCompareLocation();

        /*
         * Setup state observer for current planable term store
         */
        this.currentPlanableTermStoreDisposer = observe(termStore, "state", (change) => {
            // Set the data state for this store to the new value.
            this.dataLoadStates.currentPlanableTerm = change.newValue;
            // Precipitate a UI update if the data loads have completed.
            this.checkDataLoadStates();
        });

        termStore.load('currentPlanableTerm');

        this.dataLoadStates.internalProcessing = States.done;

        if (appStore.isDevMode()) {
            console.log('AppNavigationStore loaded');
        }

        this.checkDataLoadStates();
    }

    unmount() {
        this.currentPlanableTermStoreDisposer();
    }

    resetNavigationCompareLocation() {
        this.navigationCompareLocation = this.buildCompareLocation();
        this.navigationComparePathname = this.buildCompareLocationPathname();
    }

    buildCompareLocation() {

        // for the purposes of comparing navigation locations, we can ignore any query parameters in the hash portion
        let locationHash = stripQueryParams(window.location.hash);

        return this.buildCompareLocationPathname() + locationHash;
    }

    /**
     * Builds a string appropriate for comparing just the path name
     * Used for navigation links like '/course' and '/program' that don't use the hash portion of the location
     *
     */
    buildCompareLocationPathname() {
        return window.location.pathname;
    }

    /**
     * Check aggregate data load states and update the overall state if necessary.
     */
    checkDataLoadStates() {
        this.state = getAggregateState(this.dataLoadStates);
    }

    /**
     * pass-thru to CurrentPlanableTermStore
     */
    getCurrentPlanableTerm() {
        return termStore.get('currentPlanableTerm');
    }

}

export default new AppNavigationStore();